import { render } from "./FapiaoList.vue?vue&type=template&id=45810898&scoped=true&ts=true"
import script from "./FapiaoList.vue?vue&type=script&lang=ts"
export * from "./FapiaoList.vue?vue&type=script&lang=ts"

import "./FapiaoList.vue?vue&type=style&index=0&id=45810898&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45810898"]])

export default __exports__